import { render } from "./TranscriptionItem.vue?vue&type=template&id=5de6e969&scoped=true&ts=true"
import script from "./TranscriptionItem.vue?vue&type=script&lang=ts"
export * from "./TranscriptionItem.vue?vue&type=script&lang=ts"

import "./TranscriptionItem.vue?vue&type=style&index=0&id=5de6e969&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de6e969"]])

export default __exports__